import type { IconSvgObject } from './types';

const ArrowLeft05Icon: IconSvgObject = [
  ["path", { d: "M3.99869 6L3.99869 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.99869 12L11.9987 16L11.9987 8L6.99869 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 12H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowLeft05Icon;
